module.exports = __webpack_public_path__ + "static/media/cl.dfefa273.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/cl.svg
// module id = 887
// module chunks = 0